import React, { Component } from "react";
import { Navigate, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import { updateProfileAction } from 'actions/adminActions';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import {Modal} from "react-bootstrap";

// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  CardTitle,
  CardBody,
  Input,
  InputGroupText,
  InputGroup,
  Button
} from "reactstrap";

class AdminProfilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFocus: false,
      lastFocus: false,
      show: false,
      modalOKEnabled: false
    }
    this.setShow = this.setShow.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    document.title = 'Update Profile';
    if (!this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/adminprofile';
    }
  }

  componentWillUnmount() {
    if(this.props.response && 
      this.props.response.admin &&
        this.props.response.admin.response)
      delete this.props.response.admin.response;
  }

  setShow(bool) {
    this.setState({ show: bool });
  }
  handleClose = () => { 
    this.setShow(false); 
    this.props.navigate('/liquidlove/requests');
  };
  
  handleShow = () => { this.setShow(true) };

  render() {
    if (!this.props.response.login.isSignedIn) {
      return <Navigate to={'/liquidlove/login'} />
    }

    let isSuccess, message;

    if (this.props.response.admin && this.props.response.admin.hasOwnProperty('response')){
      this.state.modalOKEnabled = true;
      if(this.props.response.admin.response.hasOwnProperty('status'))
        if(this.props.response.admin.response.status === 'success')
          isSuccess = true;
        else if(this.props.response.admin.response.status === 'error'){
          isSuccess = false;
          message = this.props.response.admin.response.message ? 
          this.props.response.admin.response.message
          : 'Sairam! Update is NOT successful';
        }
    }

    if(isSuccess)
      message = 'Sairam! Update is successful';
    
    return (      
      <Formik
            initialValues={{
                adminId: '',
                email: '',
                phone: ''
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .required('email is required')              
                .email('email is invalid'),
              phone: Yup.number()                
                .required('phone is required')
                .test('len', 'Please enter 10 digits', val => val && val.toString().length === 10 )                
                .positive('Please provide valid phone number'),
            })}
        onSubmit={fields => {
            let id = this.props.response.login.adminId;            
            let email = fields.email;
            let phone = fields.phone;
            let token = this.props.response.login.userToken;
            const data = {
              id, email, phone
            }

            const payload = {
              token, data
            }
            this.handleShow();
            this.props.dispatch(updateProfileAction(payload));
        }  
      }
        render={({ errors, status, touched }) => (                    
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div  className="section section-signup"
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
                <Row>
                  <Card className="card-signup" data-background-color="blue">
                    <CardHeader className="text-center">
                        <CardTitle className="title-up" tag="h3">
                            Update Profile                            
                        </CardTitle>                  
                    </CardHeader>
                    <CardBody>
                      {message}
                      <Form>
                        <Modal
                          centered
                          show={this.state.show}
                          onHide={this.handleClose}
                          backdrop="static"
                          keyboard={false}
                          >
                            <Modal.Body>
                              {message ? message : 'Sairam! Processing your request.'}
                            </Modal.Body>
                            <Modal.Footer>
                              <Button disabled={!this.state.modalOKEnabled} className="btn btn-primary mr-2" variant="primary" onClick={this.handleClose}>
                                OK
                              </Button>
                            </Modal.Footer>
                        </Modal>
                  <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        email
                      </InputGroupText>
                    <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                    <ErrorMessage name="email" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        Phone
                      </InputGroupText>
                    <Field name="phone" type="text" className={'form-control' + (errors.phone && touched.phone ? ' is-invalid' : '')} />
                    <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <div className="col text-center">
                  <button type="submit" size="lg" outline className="btn btn-primary">Save</button>
                  </div>
                      </Form>
                    </CardBody>                             
                </Card>
              </Row>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
      />
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  return <AdminProfilePage navigate={navigate} {...props} />
});